import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/courseCategory?${params}`);
  },
  getAllList() {
    return api.get(`/api/courseCategory`);
  },
  getById(id) {
    return api.get(`/api/courseCategory/byid/${id}`);
  },
  update(id, data) {
    return api.put(`/api/courseCategory/${id}`, data);
  },
  create(data) {
    return api.post(`/api/courseCategory`, data);
  },
  delete(id) {
    return api.delete(`/api/courseCategory/${id}`);
  },
};
